<div *ngIf="data.length > 0; else: elseBlock" fxLayout>
  <div style="height: 10px; width: 10px; border-radius: 50%; margin-right: 5px;" class="ea-primary-bg"
    *ngFor="let counter of data">
  </div>
</div>

<ng-template #elseBlock>
  <div>{{utils.traslatei18n('all')}}</div>
</ng-template>